var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"anchor",class:[_vm.mode],attrs:{"href":_vm.link,"target":_vm.target},on:{"click":(evt) => _vm.$emit('onClick', evt)}},[(_vm.hasIcon)?_c('AssetV3',{staticClass:"icon",attrs:{"dir":"icons","name":_vm.iconName}}):_vm._e(),_c('p',{staticClass:"anchor-text white"},[_vm._v(_vm._s(_vm.content))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }